import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=0463d1a2&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=0463d1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463d1a2",
  null
  
)

export default component.exports